import { InputHTMLAttributes } from 'react';

import * as State from 'components/desktop/_general/Input/RoundedInput/RoundedInputState';
import useRoundedInputState from 'components/desktop/_general/Input/RoundedInput/useRoundedInputState';

interface IProps extends InputHTMLAttributes<any> {
	handleChange: (input: number) => void;
	value: number;
	dataComponentType?: string;
	dataComponentKey?: string;
}

const RoundedInput = ({ handleChange, value, ...props }: IProps) => {
	const { state, handlers } = useRoundedInputState();

	const { dataComponentType, dataComponentKey, ...restProps } = props;

	return (
		<input
			className="form-control"
			data-component-type={props.dataComponentType}
			data-component-key={props.dataComponentKey}
			{...restProps}
			type="text"
			onChange={(e) => handlers.setValue(e.currentTarget.value)}
			value={State.getDisplayValue(state, value)}
			onFocus={() => handlers.onFocus(String(value))}
			onBlur={() => {
				handleChange(State.getValue(state, value));
				handlers.setIsActive(false);
			}}
		/>
	);
};

export default RoundedInput;
